import { useEffect, useState } from "react";
import "./App.css";
import db from "./firebase";

function App() {
  const [animals, setAnimals] = useState([]);

  useEffect(() => {
    const recentDate = new Date(
      new Date().setDate(new Date().getDate() - 4),
    ).getTime();
    db.ref("/found")
      .orderByChild("createdAt")
      .startAt(recentDate)
      .on("value", (snaps) => {
        let animals = [];
        snaps.forEach((snap) => {
          const foundUser = snap.val();
          db.ref("/animals")
            .child(snap.key)
            .once("value", (animalSnap) => {
              animals = [
                ...animals,
                { photoURL: animalSnap.val().photoURL, type: foundUser.type },
              ];
              setAnimals(animals);
            });
        });
      });
  }, []);

  return (
    // uncomment below and get rid of existing return if Animal Services ever requests to only see the animals the town posted.
    //<div className="App">
    //   {animals.map((animal) =>
    //     animal.type !== "citizen" ? (
    //       <>
    //         <img
    //           src={animal.photoURL}
    //           key={animal.photoURL}
    //           alt={"found dog"}
    //         />
    //         {/* <p>{animal.type}</p> */}
    //       </>
    //     ) : (
    //       ""
    //     ),
    //   )}
    // </div>
    <div className="App">
      {animals.map((animal) => (
        <>
          <img src={animal.photoURL} key={animal.photoURL} alt={"found dog"} />
          {/* <p>{animal.type}</p> */}
        </>
      ))}
    </div>
  );
}

export default App;
